import './register-transaction.css'
import * as React from 'react'
import TransactionForm from '../../components/transaction-form/transaction-form'

/**
 * Register Transaction Component.
 * Represents the transaction registration page.
 *
 * @returns {React.ReactElement} - Register Transaction Component.
 */
const RegisterTransaction = () => {
  return <TransactionForm />
}

export default RegisterTransaction
